import { render } from "./App.vue?vue&type=template&id=1590e42e"
const script = {}
script.render = render

export default script